<template>
    <div>

        <!--导航栏 start-->
        <div class="main">
            <div class="main-div">
                <van-nav-bar
                        title="交易日报"
                        left-text="返回"
                        @click-left="onClickLeft"
                        left-arrow
                        fixed
                />
                <!--导航栏 end-->
                <!--内容 start-->
                <div style="margin-top: 1.2rem">

                            <van-dropdown-menu>
                                <van-dropdown-item  ref="items" :title="merchant_id==''?'全部商户':merchant_name">
                                   <div style="height: 13rem;overflow-y: scroll">
                                     <van-cell @click="pagexmer()"  title="全部商户" is-link/>
                                     <div v-for="(bububu,index) in option2" :key="index">
                                         <van-cell @click="outlets(bububu.value,bububu.label)" :title="bububu.label" is-link/>
                                     </div>
                                   </div>
                                </van-dropdown-item>

                                <van-dropdown-item  ref="item" :title="store_id==''?'全部门店':store_name" style="overflow-y:auto;">
                                    <van-cell @click="pagex()"  title="全部门店" is-link/>
                                    <div v-for="(bububu,index) in option1" :key="index">
                                        <van-cell @click="outlet(bububu.value,bububu.label)" :title="bububu.label" is-link/>
                                    </div>
                                </van-dropdown-item>
                            </van-dropdown-menu>

<!--                            <van-dropdown-menu >-->
<!--                               -->
<!--                            </van-dropdown-menu>-->

                    <van-tabs class="van_tabs" color="rgb(0,170,238)" title-active-color="black" @click="onClick(active)"  id="vat_tabs" v-model="active">
                        <van-tab  title="日报表">
                            <van-grid :column-num="3" :border="false" id="vat_grid" >
                                <van-grid-item  text="交易时间" />
                                <!-- <van-grid-item  text="门店" /> -->
                                <van-grid-item  text="交易笔数" />
                                <van-grid-item  text="交易金额" />
                            </van-grid>
                        </van-tab>
                        <van-tab title="周报表">
                            <van-grid :column-num="3" :border="false" id="vat_grid">
                                <van-grid-item  text="交易时间" />
                                <!-- <van-grid-item  text="门店" /> -->
                                <van-grid-item  text="交易笔数" />
                                <van-grid-item  text="交易金额" />
                            </van-grid>
                        </van-tab>
                        <van-tab title="月报表">
                            <van-grid :column-num="3" :border="false" id="vat_grid">
                                <van-grid-item  text="交易时间" />
                                <!-- <van-grid-item  text="门店" /> -->
                                <van-grid-item  text="交易笔数" />
                                <van-grid-item  text="交易金额" />
                            </van-grid>
                        </van-tab>
                    </van-tabs>
                </div>
            </div>
        </div>
        <!--内容 end-->
        <div  class="content">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div v-for="(admin,index) in list" :key="index">
                    <van-grid :column-num="3" :border="false">
                        <van-grid-item  :text="admin.date" />
                        <van-grid-item  :text="admin.summary_collest_count+'笔'" />
                        <van-grid-item  :text="admin.summary_collest+'元'" />
                    </van-grid>

                </div>
            </van-list>
        </div>



    </div>
</template>

<script>
    // import {Toast} from 'vant';

    import VueCookie from "vue-cookies";

    export default {
        name: "AgentSummary", //交易汇总
        data(){
            return{
                active:0,
                list:[],
                option1:[],
                option2:[],
                store_id:'',
                merchant_id:'',
                store_name:'',
                merchant_name:'',
                forms:"",
                loading: false,
                finished: false,
                page:0,
                num:10,

                salesmanInfo:VueCookie.get("salesmanInfo")
            }
        },
        methods: {
            // 左侧返回
            onClickLeft() {
                this.$router.go(-1);
            },
            //初始化时默认是日报表
            daily(){
                this.forms="day"
                // console.log(this.forms);
            },
            //点击报表类型
            onClick(active){
                if (active=="0") {
                    this.forms="day"
                    this.page=0
                    this.list=[]
                    this.onLoad()
                    // console.log(this.forms);

                }else if(active=="1"){
                    this.forms="week"
                    this.page=0
                    this.list=[]
                    this.onLoad()
                    // console.log(this.forms);

                }else if(active=="2"){
                    this.forms="month"
                    this.page=0
                    this.list=[]
                    this.onLoad()
                    // console.log(this.forms);

                }

            },

            //查询商户列表
            theMerchants(){
                this.$http.get('/wechat/api.agent.pay/merchants').then(response => {
                    // console.log(response.data.data);
                    this.option2=response.data.data
                    // this.number()
                    this.page=0
                    this.list=[]
                    this.onLoad()
                })
            },

            //根据商户id查询门店
            theStores(){
                this.$http.get('/wechat/api.agent.pay/stores', {
                    params: {
                        merchant_id:this.merchant_id
                    }
                }).then(response => {
                    console.log(response.data.data);
                    this.option1=response.data.data

                })
            },
            pagexmer(){
                this.merchant_id="";
                this.store_id='';
                this.option1=[];
                this.page=0;
                this.list=[];
                //控制下拉菜单收起
                this.$refs.items.toggle();
                this.onLoad()
            },
            pagex(){
                this.store_id="";
                this.page=0;
                this.list=[];
                //控制下拉菜单收起
                this.$refs.item.toggle();
                this.onLoad()
            },
            //默认选择第一家门店
            // number(){
            //     if (this.store_id=="") {
            //         this.store_id=this.option1[0].merchant_id
            //         this.store_name=this.option1[0].bse_lice_nm
            //     }
            // },
            outlets(a,b){
                this.merchant_id=a;
                this.merchant_name=b;
                this.store_id='';
                this.$refs.items.toggle();
                //    this.choose()
                this.theStores()
                this.page=0
                this.list=[]
                this.onLoad()
            },

            //门店选择
            outlet(a,b){
                this.store_id=a;
                this.store_name=b;
                console.log(a,b);
                this.$refs.item.toggle();
                //    this.choose()
                this.page=0
                this.list=[]
                this.onLoad()

            },

            // 触发下拉刷新更多
            onLoad() {
                this.page+=1;
                this.report()
            },
            //报表
            report(){
                var that=this
                this.$http.get('/wechat/api.agent.pay/getStoreStatistics', {
                    params: {
                        merchant_id:this.merchant_id,
                        store_id:this.store_id,
                        type:this.forms,
                        pageNum:this.page,
                        pageSize:this.num

                    }
                }).then(response => {
                    // console.log(response.data.data);
                    // this.list=response.data.data
                    that.loading=false;
                    if (response.data.rows.length) {
                        that.list.push(...response.data.rows);
                        that.finished = false;
                    }
                    if (response.data.rows.length < that.num)
                    {
                        that.finished = true;
                    }
                })
            }


        },
        mounted(){
            this.daily()
            this.theMerchants()

        }
    }
</script>

<style scoped>
    #vat_tabs{
        font-size:0.6rem;
        /* border: solid 2px red; */

    }
    #vat_grid{
        position: relative;
        bottom: 0.1rem;
    }
    .main{
        /* position: sticky;
        top: 1.22rem; */
        z-index: 1000;
        position: relative;
    }
    .main-div{
        position: fixed;
        top: 0;
        width:100%;
    }
    .content{
        margin-top: 4.8rem;
        /* border: solid 1px red; */
    }
    .van_tabs{
        /* border: solid 1px red; */
        position: relative;
        bottom: 0.1rem;
    }
    #van_menu{
        width: 46%;
    }
</style>
